module.exports = __webpack_public_path__ + "h5/img/li_n.021a7a5b.jpg";